import React from "react";

// Mobiscroll's Eventcalendar renders an event's title, and any string a
// render callback returns, through dangerouslySetInnerHTML. Titles built from
// user data (client names) must go through these renderers instead, which
// return React elements so the title is rendered as text.

// Month-view label (calendar={{ labels: true }}).
export const renderCalendarLabelText = (data) => (
  <span>{data.original?.title}</span>
);

// Event rows in the agenda and the "+N more" popover.
export const renderCalendarEventText = (event) => (
  <div className="mbsc-event-text" title={event.original?.title}>
    {event.original?.title}
  </div>
);
